module.exports = __webpack_public_path__ + "img/light-fm-Path 42@3x.383b13c7.png";